import { UploadFileHints } from '@/components/popups/filesUploadPopup/components/UploadFile'
import { errorToast } from '@/utils/toasters'
import { useRef, useState } from 'react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'


const iconMap = {
    pdf: 'teenyicons:pdf-solid',
    image: 'mdi-light:image',
    word: 'vscode-icons:file-type-word',
    excel: 'vscode-icons:file-type-excel',
    document: 'line-md:document',
    video: 'icon-park-outline:video',
    other: 'line-md:document',
    text: 'line-md:document',
    presentation: 'vscode-icons:file-type-powerpoint2',
    audio: 'streamline-ultimate:audio-file-bold',
    archive: 'subway:zip',
    code: 'solar:code-line-duotone',
}
const fileformats = {
    "image": ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp", "ico", "tiff", "heic"],
    "pdf": ["pdf"],
    "word": ["doc", "docx", "odt"],
    "excel": ["xls", "xlsx", "csv", "ods"],
    "text": ["txt", "rtf", "md"],
    "presentation": ["ppt", "pptx", "odp"],
    "video": ["mp4", "avi", "mov", "mkv", "webm", "flv", "wmv", "mpeg", "mpg", "m4v", "3gp"],
    "audio": ["mp3", "wav", "flac", "aac", "ogg", "m4a"],
    "archive": ["zip", "rar", "7z", "tar", "gz"],
    "code": ["js", "py", "java", "c", "cpp", "html", "css", "json", "xml", "php"],
    "other": ["*"]
};
// iam using it for err msgs with translation
const commonFileErrs = {
    size:"file-size-error",
    type:"file-type-error",
    count:"max-files-error",
    maxFilesError:"max-files-error",
    maxFilesErrorRemove:"max-files-error-remove",
    fileTypeError:"file-type-error",
    fileTypeErrorRemove:"file-type-error-remove",
    fileSizeError:"file-size-error",
    fileSizeErrorRemove:"file-size-error-remove"
}

const useFileUpload = (value, setValue, multiple, maxfilesize = 5000, maxfiles = 100, accept) => {
    const { t } = useTranslation()
    const maxSizeInBytes = maxfilesize * 1024 * 1024
    const supportedTypes = accept?.flatMap(type => (t(UploadFileHints[type]) || '').split(',').map(s => s.trim().toLowerCase())) ?? [];
    const inputRef = useRef(null)
    const dropZoneRef = useRef(null)
    const [isDragging, setIsDragging] = useState(false)
    const [errors, setErrors] = useState([])

    useEffect(() => {
        if (value?.length === 0 && inputRef.current)
            inputRef.current.value = ""
    }, [value])

    const stopDefaultEvent = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }
    const getFileExtension = (file) => {
        const fileName = file?.name
        if (!fileName) return "other"
        const fileExtension = fileName?.split('.')?.pop()?.toLowerCase()
        return fileExtension
    }

    const getFileFormat = (file) => {
        const fileName = file?.name
        if (!fileName) return "other"
        const fileExtension = getFileExtension(file)
        if (!fileExtension) return "other"
        const found = Object.entries(fileformats).find(([key, values]) => values.includes(fileExtension))
        return found ? found[0] : "other"
    }

    const getFileIcon = (file) => {
        const format = getFileFormat(file)   
        return iconMap[format] || 'mdi:file-document-outline'
    }

    // const handleFileSelect = (files) => {
    //     const filesArray = [...files]
    //     const newErrors = []
    //     // const supportedTypes = accept?.map((type) => t(UploadFileHints[type]))?.map((type) => type?.split(",")?.map((type) => type?.trim()?.toLowerCase())).flat()

    //     if (!multiple) {
    //         const file = filesArray[0]
    //         if (!file) return
    //         if (file.size > maxSizeInBytes) {
    //             setErrors([commonFileErrs.size])
    //             errorToast(commonFileErrs.size)
    //             return
    //         }
    //         if(!supportedTypes?.includes(getFileFormat(file))){
    //         setErrors([commonFileErrs.type])
    //         errorToast(commonFileErrs.type)
    //         return
    //     }
    //         setErrors([])
    //         setValue([file])
    //         return
    //     }


    //     const existingFileKeys = new Set(
    //         value.map(f => `${f.name}-${f.size}-${f.type}`)
    //     )
        
    //     const uniqueNewFiles = filesArray.filter(file => {
    //         const fileKey = `${file.name}-${file.size}-${file.type}`
    //         return !existingFileKeys.has(fileKey)
    //     })

    //     const newFilesCount = uniqueNewFiles.length

    //     if (value.length + newFilesCount > maxfiles) {
    //         newErrors.push("max-files-error")
    //         errorToast("max-files-error-remove")
    //         setValue([...value, ...uniqueNewFiles].slice(0, maxfiles))
    //         return
    //     }

        
    //     const invalidFileType = uniqueNewFiles.some(file => !supportedTypes?.includes(getFileFormat(file)))

    //     if (invalidFileType) {
    //         newErrors.push("file-type-error")
    //         errorToast("file-type-error-remove")
    //         setValue(value.filter((_, i) => !invalidFilesType.includes(i)))
    //         return
    //     }

    //     const hasInvalidFileSize = uniqueNewFiles.some(file => file.size > maxSizeInBytes)
    //     const invalidFileSize = uniqueNewFiles.filter(file => file.size > maxSizeInBytes)
    //     if (hasInvalidFileSize) {
    //         newErrors.push("file-size-error")
    //         errorToast("file-size-error-remove")
    //         setValue(value.filter((_, i) => !invalidFileSize.includes(i)))
    //         return
    //     }

    //     setErrors(newErrors)
        
        

    //     setValue([...value, ...uniqueNewFiles])
    // }


        const handleFileSelect = (files) => {
        const filesArray = [...files]
        const errors = []

        if (!multiple) {
            const file = filesArray[0]
            if (!file) return
            if (file.size > maxSizeInBytes) {
                setErrors([commonFileErrs.size])
                errorToast(commonFileErrs.size)
                return
            }
            if (!supportedTypes?.includes(getFileExtension(file))) {
                setErrors([commonFileErrs.type])
                errorToast(commonFileErrs.type)
                return
            }
            setErrors([])
            setValue([file])
            return
        }

        const existingFileKeys = new Set(
            value.map(f => `${f.name}-${f.size}-${f.type}`)
        )
        
        const uniqueNewFiles = filesArray.filter(file => {
            const fileKey = `${file.name}-${file.size}-${file.type}`
            return !existingFileKeys.has(fileKey)
        })

        if (value.length + uniqueNewFiles.length > maxfiles) {
            const allowedFiles = [...value, ...uniqueNewFiles].slice(0, maxfiles)
            errors.push(commonFileErrs.maxFilesError)
            errorToast(commonFileErrs.maxFilesErrorRemove)
            setValue(allowedFiles)
            setErrors(errors) 
            return
        }

        const validFiles = []
        const invalidFiles = []
        
        for (const file of uniqueNewFiles) {
            const fileType = getFileExtension(file)
            const isValidType = supportedTypes?.includes(fileType)
            const isValidSize = file.size <= maxSizeInBytes
            
            if (isValidType && isValidSize) {
                validFiles.push(file)
            } else {
                invalidFiles.push(file)
                if (!isValidType && !errors.includes(commonFileErrs.fileTypeError)) {
                    errors.push(commonFileErrs.fileTypeError)
                    errorToast(commonFileErrs.fileTypeErrorRemove)
                }
                if (!isValidSize && !errors.includes(commonFileErrs.fileSizeError)) {
                    errors.push(commonFileErrs.fileSizeError)
                    errorToast(commonFileErrs.fileSizeErrorRemove)
                }
            }
        }

        if (errors.length > 0) {
            setErrors(errors)
            setValue([...value, ...validFiles])
            return
        }

        setErrors([])
        setValue([...value, ...validFiles])
    }

    const handleDragEnter = (e) => {
        stopDefaultEvent(e)
        setIsDragging(true)
    }

    const handleDragLeave = (e) => {
        stopDefaultEvent(e)
        setIsDragging(false)
    }

    const handleDrop = (e) => {
        stopDefaultEvent(e)
        setIsDragging(false)
        const files = e.dataTransfer.files
        if (files && files.length > 0) {
            handleFileSelect(files)
        }
    }

    const handleInputChange = (e) => {
        const files = e.target.files
        if (files && files.length > 0) {
            handleFileSelect(files)
        }
    }

    const formatFileSize = (bytes) => {
        if (!bytes) return ''
        if (bytes < 1024) return bytes + ' B'
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB'
        return (bytes / (1024 * 1024)).toFixed(2) + ' MB'
    }

    const handleRemove = (e,item) => {
        stopDefaultEvent(e)
        setValue(value.filter((i) => i?.name !== item?.name))
        if (inputRef.current) inputRef.current.value = ""
    }

 

    return {
        isDragging,
        dropZoneRef,
        inputRef,
        getFileIcon,
        formatFileSize,
        getFileFormat, 
        handleFileSelect,
        handleDragEnter,
        handleDragLeave,
        handleDrop,
        handleInputChange,
        handleRemove,
        stopDefaultEvent,
        errors
    }
}

export default useFileUpload